export default {
  // FRENCH
  properties: "Les propriétés",
  create: "Créer une propriété",
  modify: "Modifier une propriété",
  property: "Fiche propriété",
  back: "Les Propriétés",
  no_property:"Pas de propriété",
  title: {
    title: "Titre de la propriété",
    placeholder: "Ajouter un titre",
  },
  is_activated: "Activé",
  description: {
    title: "Description de la propriété",
    placeholder: "Ajouter une description",
  },
  type: {
    title: "Type de bien",
    villa: "Villa",
    flat: "Appartement",
    house: "Maison",
    office: "Bureau",
    land: "Terrain",
    garage: "Garage",
    bungalow: "Bungalow",
    duplex: "Duplex",
    professional_office: "Professional Office",
    building: "Building",
    industrial_land: "Industrial Land",
    agricultural_land: "Agricultural Land",
    penthouse: "Penthouse",
  },
  status: {
    title: "Statut",
    sell: "A vendre",
    rent: "A louer",
    sold: "Sold",
    booked: "Booked",
    stock_in_trade: "Stock in trade",
  },
  availability: "Disponibilité",

  price: "Prix",

  // Box content
  labels: {
    specifications: "Caractéristiques",
    options: "Options",
  },
  construction: {
    title: "Construction",
    new: "Neuf",
    used: "Utilisé",
    reworked: "Réformé",
  },
  indoor_area: "Superficie habitation",
  land_area: "Superficie terrain",
  total_area: "Superficie totale",
  bedrooms: "Chambres",
  bathrooms: "Salles d'eau",
  swimming_pool: {
    title: "Piscine",
    community: "Communautaire",
    private: "Privée",
  },
  car_park: {
    title: "Parking",
    garage: "Garage",
    public: "Public",
    private: "Privé",
  },
  parking: "Garage",
  furniture: "Meublé",
  disabled_access: "Accès handicapé",
  beach_distance: "Distance plage",
  sun_orientation: "Orientation solaire",
  charges: "Charges",
  land_register: "Cadastre",

  // TO ADD
  terrace: "Terrasse",
  patio: "patio",
  terrace_area: "Surface terrasse",
  patio_area: "Surface patio",
  energy_performance: "Performance énergétique",
  sea_sight: "Vue sur mer",
  shops_distance: "Distance commerces",
  floor: {
    title: "Etage",
    ground_floor: "Rez-de-chaussée",
  },
  in_golf: "Golf",

  // OPTIONS
  air_conditioning: "Air conditionné",
  solarium: "Solarium",
  elevator: "Ascenseur",
  wifi: "Wifi",
  spa: "Spa",
  fitness: "Salle de sport",
  animals: {
    title: "Animaux",
    allowed: "Admis",
    not_allowed: "Non admis",
  },

  // RIGHT PANEL
  no_image: "Pas d'image",
  manage_images: "Gérer les images",
  reference: "Référence",

  //TAGS
  tags: "Tags",
  new_price: "Nouveau prix",
  opportunity: "Opportunité",
  new_property: "Nouveau bien",

  address: {
    title: "Adresse",
    street: "Rue",
    number: "Numéro",
    postcode: "Code postal",
    city: "Ville",
    region: "Région",
    province: "Province",
    country: "Pays",
    placeholder: "Ex: Rue d'Andrimont 108, Barchon, Belgique",
  },
  library: {
    title: "Gestion des photos",
    add_picture: "Ajouter une photo",
    no_picture: "Vous n'avez pas de photo !",
    drag_and_drop: "Glissez vos fichiers pour en ajouter.",
  },

  notification: {
    created: "Propriété créée",
    updated: "Modifications enregistrées",
    deleted: "Propriété supprimée",
  },
  // PROPERTIES
  name: "nom",
  location: "lieu",
  main_specs: "Caractéristiques principales",
  second_specs: "Caractéristiques secondaires",
  associated_key: "Associated Key",
    partner:"Partner",

  confirm_delete: "Etes-vous sûr de vouloir supprimer cette propriété ?",
  loading_properties:"Loading properties..."
};
